// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__3hg5W","loader":"Loader_loader__2dRv0"};